import api from './api';

export async function getTickets() {
  const res = await api.get('/support/tickets');
  return res.data.data;
}

export async function getTicket(id) {
  const res = await api.get(`/support/tickets/${id}`);
  return res.data.data;
}

export async function createTicket({ subject, description, category }) {
  const res = await api.post('/support/tickets', { subject, description, category });
  return res.data.data;
}

export async function addTicketComment(id, text) {
  const res = await api.post(`/support/tickets/${id}/comments`, { text });
  return res.data.data;
}
